export class MissingElementError extends Error {
  readonly elementId: string

  constructor(elementId: string) {
    super(`Required element is missing or has the wrong type: ${elementId}`)
    this.name = "MissingElementError"
    this.elementId = elementId
  }
}

export function htmlElement(id: string): HTMLElement {
  const found = document.getElementById(id)
  if (found === null) throw new MissingElementError(id)
  return found
}

export function buttonElement(id: string): HTMLButtonElement {
  const found = htmlElement(id)
  if (!(found instanceof HTMLButtonElement)) throw new MissingElementError(id)
  return found
}

export function inputElement(id: string): HTMLInputElement {
  const found = htmlElement(id)
  if (!(found instanceof HTMLInputElement)) throw new MissingElementError(id)
  return found
}

export function selectElement(id: string): HTMLSelectElement {
  const found = htmlElement(id)
  if (!(found instanceof HTMLSelectElement)) throw new MissingElementError(id)
  return found
}

export function canvasElement(id: string): HTMLCanvasElement {
  const found = htmlElement(id)
  if (!(found instanceof HTMLCanvasElement)) throw new MissingElementError(id)
  return found
}
